"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildFieldName = exports.transformFilterableFields = exports.sentenceCase = exports.sleep = void 0;
// TODO: Fix this later
// @ts-nocheck
const upperFirst_1 = __importDefault(require("lodash/upperFirst"));
const lowerCase_1 = __importDefault(require("lodash/lowerCase"));
const capitalize_1 = __importDefault(require("lodash/capitalize"));
const camelCase_1 = __importDefault(require("lodash/camelCase"));
const sleep = (timeInMS) => new Promise((resolve) => {
    setTimeout(resolve, timeInMS);
});
exports.sleep = sleep;
const sentenceCase = (text = '') => (0, upperFirst_1.default)((0, lowerCase_1.default)(text || ''));
exports.sentenceCase = sentenceCase;
function transformFilterableFields(iterableFields) {
    const record = [];
    for (const [propertyKey, propertyValue] of Object.entries(iterableFields)) {
        if (!Number.isNaN(Number(propertyKey))) {
            continue;
        }
        record.push({ value: propertyValue, key: (0, capitalize_1.default)((0, lowerCase_1.default)(propertyKey)) });
    }
    return record;
}
exports.transformFilterableFields = transformFilterableFields;
const buildFieldName = (prefix, name) => (prefix ? (0, camelCase_1.default)(`${prefix} ${name}`) : name);
exports.buildFieldName = buildFieldName;
